/* eslint-disable @typescript-eslint/camelcase */
import { Grid, makeStyles } from '@material-ui/core';
import Button from 'components/Button';
import DatePicker from 'components/DatePicker';
import { Formik } from 'formik';
import i18n from 'i18n';
import { FormStopTime } from 'modules/environments/interfaces';
import React from 'react';
import formStyles from '../../Form/styles';

const useStyles = makeStyles(formStyles);

const initial: FormStopTime = {
  stop_time: null,
  new_stop_time: null,
};

export interface Props {
  initialValues?: typeof initial;
  onCancel: () => void;
  onSubmit: (values) => void;
}

export default function FormNewStopTime({
  initialValues = initial,
  onCancel,
  onSubmit,
}: Props) {
  const classes = useStyles();

  return (
    <Grid item container data-testid={'autosky-formnewscheduledstop'}>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {({ setFieldValue, submitForm, values }) => (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <DatePicker
                id="stop_time"
                type="datetime"
                label={i18n.t('SCHEDULED_STOP_DATETIME_KEY')}
                keyValue="stop_time"
                value={values.stop_time}
                setFieldsValue={setFieldValue}
                disabled
              />
            </Grid>
            <Grid item xs={12}>
              <DatePicker
                id="new_stop_time"
                type="datetime"
                label={i18n.t('NEW_SCHEDULED_STOP_DATETIME_KEY')}
                keyValue="new_stop_time"
                value={values.new_stop_time}
                minDate={values.stop_time}
                setFieldsValue={setFieldValue}
              />
            </Grid>

            <Grid container justify="flex-end" className={classes.buttonsBase}>
              <Grid container className={classes.buttonsAlign}>
                <Button id="submit-button" onClick={submitForm} submitButton>
                  {i18n.t('ADD_KEY')}
                </Button>
                <Button
                  id="cancel-button"
                  variant="outlined"
                  onClick={onCancel}
                >
                  {i18n.t('CANCEL_KEY')}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Formik>
    </Grid>
  );
}
